import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconBrain: FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M9.96064 14.5982C9.96064 16.0035 8.76712 17.1428 7.29483 17.1428C5.90649 17.1428 4.76603 16.1298 4.64048 14.8358C2.95377 14.5711 1.66699 12.9789 1.66699 9.82139C1.66699 6.66384 2.95377 5.07165 4.64048 4.80696C4.76603 3.51302 5.90649 2.49996 7.29483 2.49996C8.76712 2.49996 9.96064 3.63924 9.96064 5.04461C9.96064 7.52695 9.96064 12.4249 9.96064 14.5982Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0394 5.04464C10.0394 3.63928 11.2329 2.5 12.7052 2.5C14.0935 2.5 15.234 3.51306 15.3595 4.807C17.0462 5.07168 18.333 6.66388 18.333 9.82143C18.333 12.979 17.0462 14.5712 15.3595 14.8359C15.234 16.1298 14.0935 17.1429 12.7052 17.1429C11.2329 17.1429 10.0394 16.0036 10.0394 14.5982C10.0394 12.1159 10.0394 7.21794 10.0394 5.04464Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.83261 7.53843C6.60043 7.51636 8.05127 6.97141 7.8589 5.29605" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    <path d="M6.41198 12.5447C5.57194 12.8248 5.01843 13.268 4.73858 14.0748" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    <path d="M13.7064 12.4999C13.7683 13.2365 14.6501 14.3131 15.9353 14.2268" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    <path d="M13.3329 5.58833C13.8416 5.67914 14.7276 5.27732 14.9008 4.39361" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    <path d="M16.3295 10.696C16.4076 9.96099 15.7445 8.73749 14.466 8.57997" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    <path d="M3.92264 9.88037C3.07218 9.92474 2.08301 8.75 1.99488 7.79731" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
  </svg>
);

IconBrain.defaultProps = defaultIconProps;
